import React from "react"
import withStyles from "@material-ui/styles/withStyles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Grid from "@material-ui/core/Grid"
import { LinearProgress } from "@material-ui/core"

import AdminTopbar from "../Admin/Topbar"
import SubscribedTopbar from "../Subscribed/Topbar"
import ModeratorTopbar from "../Moderator/Topbar"
import EvaluatorTopbar from "../Evaluator/Topbar"
import MainTopbar from "../Topbar"

import Footer from "./Footer"
import AlertMessage from "../CustomAlert"

const styles = theme => ({
    paper: {
        margin: '10px',
        padding: theme.spacing(3),
        textAlign: "left",
        color: theme.palette.text.secondary
    },
    root: {
        flexGrow: 1,
        marginTop: '72px',
    },
    grid: {
        width: 1200,
        marginTop: 40,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 20px)"
        }
    },
    rangeLabel: {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: theme.spacing(2)
    },
    topBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 32
    },
    outlinedButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1)
    },
    actionButtom: {
        textTransform: "uppercase",
        margin: theme.spacing(1),
        width: 152
    },
    blockCenter: {
        padding: theme.spacing(2),
        textAlign: "center"
    },
    block: {
        padding: theme.spacing(2)
    },
    box: {
        marginBottom: 40,
        height: 65
    },
    inlining: {
        display: "inline-block",
        marginRight: 10
    },
    buttonBar: {
        display: "flex"
    },
    alignRight: {
        display: "flex",
        justifyContent: "flex-end"
    },
    noBorder: {
        borderBottomStyle: "hidden"
    },
    loadingState: {
        opacity: 0.05
    },
    loadingMessage: {
        position: "absolute",
        top: "40%",
        left: "40%"
    }
})

const Wrapper = ({ success, loaded, children, footer, currentPath, classes, error, fatalError, subscribedTopbar, adminTopbar, moderatorTopbar, evaluatorTopbar, isChatRoomView }) => {

    if (!loaded) {
        return <LinearProgress />
    }

    return (
        <React.Fragment>
            <CssBaseline />
            {
                adminTopbar ?
                    <AdminTopbar currentPath={currentPath} />
                    :
                    subscribedTopbar ?
                        <SubscribedTopbar currentPath={currentPath} />
                        :
                        moderatorTopbar ?
                            <ModeratorTopbar currentPath={currentPath} />
                            :
                            evaluatorTopbar ?
                                <EvaluatorTopbar currentPath={currentPath} />
                                :
                                <MainTopbar currentPath={currentPath} />
            }
            <div className={classes.root}>
                <Grid
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    {
                        fatalError ?
                            <AlertMessage message={fatalError} />
                            :
                            <>
                                {error && <Grid xs={12} item><AlertMessage message={error} /></Grid>}
                                {success && <Grid xs={12} item><AlertMessage severity="success" message={success} /></Grid>}
                                <Grid xs={12} item>
                                    {children}
                                </Grid>
                            </>
                    }
                </Grid>
            </div>
            <Footer showEmail={footer} isChatRoomView={isChatRoomView} />
        </React.Fragment>
    )
}

export default withStyles(styles)(Wrapper)
